import { api } from '../configs/axiosConfigs';

export const getListingEmailStatuses = async (listSortId: string) =>
  api.get('/listing_emails', { params: { list_sort_id: listSortId } });

// Gmail / Outlook on the web: a compose link plus where to download the documents to attach.
export const getComposeLink = async (listSortId: string, propertyId: string) =>
  api.get('/listing_emails/compose', { params: { list_sort_id: listSortId, property_id: propertyId } });
